export const SideBarContent = {
    'dari': {
        "Career": "وظیفه",
        "Blog": "بلاگ",
        "Job Application": "درخواست کار",
        "English": "انگلیسی",
        "Dari": "دری",
        "Pashto": "پشتو",
        "Uzbeki": "ازبکی",
        "Dashboard": "داشبورد",
        "Admin Management": "مدیریت مدیران",
        "User Management": "مدیریت کاربران",
        "Transactions": "مبادلات",
        "MNO Management": "مدیریت اپراتورهای شبکه موبایل",
        "Onboarding/Modification Request": "درخواست شروع به کار/اِعمال تغییرات",
        "Company Management": "مدیریت شرکت",
        "Support": "پشتیبانی",
        "Reports": "گزارش‌ها",
        "Merchant Sales Report": "گزارش فروشات بر اساس فروشنده",
        "Other Reports": "سایر گزارش‌ها",
        "ZoodPay Money": "پول زودپی",
        "Other Resources": "سایر منابع",
        "Logs": "تاریخچه",
        "Master Distributor Management": "مدیریت توزیع‌کنندگان ارشد (ماستر)",
        "Distributor Management": "مدیریت توزیع کننده",
        "Sub Distributor Management": "مدیریت توزیع کننده فرعی",
        "Agent Management": "مدیریت نمایندگان",
        "Retailer Management": "مدیریت پرچون فروشان",
        "Customer Management": "مدیریت مشتریان"
    },
    'pashto': {
        "Career": "دنده/مسلک",
        "Blog": "بلاګ",
        "Job Application": "د دندې غوښتنه",
        "English": "انګلیسي",
        "Dari": "دری",
        "Pashto": "پښتو",
        "Uzbeki": "ازبکي",
        "Dashboard": "ډشبورډ",
        "Admin Management": "د مدیرانو (اډمېن) مدیریت",
        "User Management": "د کاروونکو مدیریت",
        "Transactions": "مبادلات",
        "MNO Management": "د مخابراتي شبکې د آپرېټر مدیریت",
        "Onboarding/Modification Request": "د کار پیلولو/بدلون راوستلو غوښتنه",
        "Company Management": "د شرکت مدیریت",
        "Support": "ملاتړ",
        "Reports": "راپورونه",
        "Merchant Sales Report": "د پلورونکي پر اساس د پلور راپور",
        "Other Reports": "نور راپورونه",
        "ZoodPay Money": "د زود پې پیسې",
        "Other Resources": "نورې سرچینې",
        "Logs": "تاریخچه",
        "Master Distributor Management": "د لوړ پوړو توزیع کونکو (ماسټر)مدیریت",
        "Distributor Management": "د توزیع کوونکي مدیریت",
        "Sub Distributor Management": "د فرعي توزېع کوونکي مدیریت",
        "Agent Management": "د استازي مدیریت",
        "Retailer Management": "د پرچون پلورونکو مدیریت",
        "Customer Management": "د پېرودونکو مدیریت"
    },
    'uzbeki': {
        "Career": "وظیفه",
        "Blog": "بلاگ",
        "Job Application": "ایش درخواستی",
        "English": "انگلیسی",
        "Dari": "دری",
        "Pashto": "پشتو",
        "Uzbeki": "اوزبیکی",
        "Dashboard": "داشبورد",
        "Admin Management": "مدیرلر باشقرووی",
        "User Management": "فایده‌لنوچی باشقرووی",
        "Transactions": "المشیوو",
        "MNO Management": "مبایل ترماغی اپراتورلر باشقرووی",
        "Onboarding/Modification Request": "ایشگه باشلش درخواستی/ اوزگریش کیریتیش",
        "Company Management": "شرکت مدیریتی",
        "Support": "قوللش",
        "Reports": "گزارشلر",
        "Merchant Sales Report": "ساتووچی اساسیده ساتیش گزارشی",
        "Other Reports": "باشقه گزارشلر",
        "ZoodPay Money": "زدوپی پولی",
        "Other Resources": "باشقه منبعلر",
        "Logs": "کتب رویخطینی یازیش",
        "Master Distributor Management": "اساسي توزیع قیلوچیلر باشقرووی",
        "Distributor Management": "توزیع قیلوچی باشقریش",
        "Sub Distributor Management": "فرعی توزیع قیلوچی باشقریش",
        "Agent Management": "نماینده‌لر باشقرووی",
        "Retailer Management": "چکنه (پرچون) ساتوچیلر باشقرووی",
        "Customer Management": "مشتریلر باشقرووی"
    }
};